"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.widgetName = exports.default = exports.cssAnchorName = exports.config = void 0;

var _preact = require("preact");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _phrase = _interopRequireDefault(require("../../libs/translationsUtils/phrase"));

var _publish = _interopRequireDefault(require("../../components/tracker/publish"));

var _zod = require("zod");

var _message = _interopRequireDefault(require("../design-system-components/message"));

var _GroupTags = require("./GroupTags");

var _utils = require("./utils");

var _GroupItem = _interopRequireDefault(require("./GroupItem"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var widgetName = 'group-overview_other_groups';
exports.widgetName = widgetName;
var cssAnchorName = 'widget-group_overview-other_groups';
exports.cssAnchorName = cssAnchorName;

var config = _zod.z.undefined();

exports.config = config;

var OtherGroupsOverview = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(OtherGroupsOverview, _Component);

  var _super = _createSuper(OtherGroupsOverview);

  function OtherGroupsOverview(props) {
    var _this;

    (0, _classCallCheck2.default)(this, OtherGroupsOverview);
    _this = _super.call(this, props);
    var tagCount = {};
    props.groups.otherGroups.forEach(function (group) {
      group.tags.forEach(function (tag) {
        if (tagCount[tag]) {
          tagCount[tag]++;
        } else {
          tagCount[tag] = 1;
        }
      });
    });
    _this.state = {
      selectedTags: [],
      tagCount: tagCount,
      successMessageFor: null,
      joinedGroupTitle: ''
    };
    _this.selectTag = _this.selectTag.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(OtherGroupsOverview, [{
    key: "selectTag",
    value: function selectTag(item) {
      if (this.state.selectedTags.includes(item)) {
        this.setState({
          selectedTags: this.state.selectedTags.filter(function (tag) {
            return tag !== item;
          })
        });
      } else {
        this.setState({
          selectedTags: [].concat((0, _toConsumableArray2.default)(this.state.selectedTags), [item])
        });
      }

      _publish.default.trackEvent('userevent', {
        event_source: 'control',
        // mixpanel-forwarder is ignoring any other type of event
        type: 'Group overview tag clicked',
        name: item
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$state = this.state,
          selectedTags = _this$state.selectedTags,
          successMessageFor = _this$state.successMessageFor,
          joinedGroupTitle = _this$state.joinedGroupTitle;
      var _this$props = this.props,
          groups = _this$props.groups,
          hasWidgetTitle = _this$props.hasWidgetTitle,
          hasWidgetSubtitle = _this$props.hasWidgetSubtitle;
      var otherGroups = groups.otherGroups;
      var allGroupTags = otherGroups.reduce(function (acc, group) {
        group.tags.forEach(function (tag) {
          if (!acc.includes(tag)) {
            acc.push(tag);
          }
        });
        return acc;
      }, []);
      var filteredGroups = otherGroups.filter(function (group) {
        if (!selectedTags.length) return true;
        return selectedTags.some(function (tag) {
          return group.tags.includes(tag);
        });
      });
      return (0, _preact.h)("div", {
        className: "sitewidth"
      }, (0, _preact.h)("div", {
        className: "group-overview-wrapper"
      }, successMessageFor !== null ? (0, _preact.h)(_message.default, {
        variant: "success",
        onDismiss: function onDismiss() {
          return _this2.setState({
            successMessageFor: null
          });
        },
        timer: 5000
      }, (0, _preact.h)(_phrase.default, {
        p: successMessageFor === 'joined' ? 'group.joined.successfully' : 'group.join.request.is.sent',
        count: {
          g: joinedGroupTitle
        }
      })) : null, otherGroups.length ? (0, _preact.h)("div", {
        className: "groups--other"
      }, (0, _preact.h)("h2", {
        className: "h4 group-overview-title"
      }, (0, _preact.h)(_phrase.default, {
        p: "groups.find.new.group"
      })), (0, _preact.h)(_GroupTags.GroupTags, {
        tags: allGroupTags,
        selectedTags: selectedTags,
        onTagClick: function onTagClick(tagLabel) {
          return _this2.selectTag(tagLabel);
        }
      }), (0, _preact.h)("div", {
        className: "group-overview"
      }, filteredGroups.map(function (group) {
        return (0, _preact.h)(_GroupItem.default, (0, _extends2.default)({
          key: group.id,
          onMembershipStatusChanged: function onMembershipStatusChanged(newMembershipStatus) {
            return _this2.setState({
              successMessageFor: newMembershipStatus,
              joinedGroupTitle: group.title
            });
          },
          hasWidgetTitle: hasWidgetTitle,
          hasWidgetSubtitle: hasWidgetSubtitle,
          isEvenCount: filteredGroups.length === 2 || filteredGroups.length === 4,
          origin: _utils.ORIGIN_GROUP_OVERVIEW
        }, group, {
          showGroupMeta: true
        }));
      }))) : null));
    }
  }]);
  return OtherGroupsOverview;
}(_preact.Component);

var _default = OtherGroupsOverview;
exports.default = _default;